"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var faCircleXmark_1 = require("@fortawesome/pro-light-svg-icons/faCircleXmark");
var ModalIcon_1 = __importDefault(require("../NewModal/ModalIcon"));
var ModalAlertIcon = function (_a) {
    var _b = _a.status, status = _b === void 0 ? 'success' : _b, icon = _a.icon;
    return ((0, jsx_runtime_1.jsx)(ModalIcon_1.default, { icon: icon !== null && icon !== void 0 ? icon : (status === 'error' ? faCircleXmark_1.faCircleXmark : '/GradientCheckmarkIcon.svg'), color: status === 'error' ? 'red.main' : 'primary.main' }));
};
exports.default = ModalAlertIcon;
